// Adds the DRHP AV language-tab toggle and play-button-to-native-controls
// behavior on top of the shared accordion.js and investor-toc.js, without
// modifying either. Layered independently, same convention as
// investor-toc.js: a single guarded document-level delegated listener.
if (!document.documentElement.dataset.investorTocVideoBound) {
  document.documentElement.dataset.investorTocVideoBound = 'true';

  const ACTIVE_TAB_CLASSES = ['underline', 'font-semibold'];
  const INACTIVE_TAB_CLASSES = ['no-underline', 'font-normal'];

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-ipo-video-tab]');
    if (tab) {
      const group = tab.closest('[data-ipo-video-group]');
      if (!group) return;

      const targetLang = tab.dataset.ipoVideoTab;

      for (const panel of group.querySelectorAll('[data-ipo-video-panel]')) {
        const isTarget = panel.dataset.ipoVideoPanel === targetLang;
        panel.hidden = !isTarget;

        if (!isTarget) {
          const video = panel.querySelector('video');
          video?.pause?.();
        }
      }

      for (const otherTab of group.querySelectorAll('[data-ipo-video-tab]')) {
        const isActive = otherTab === tab;
        otherTab.classList.remove(...(isActive ? INACTIVE_TAB_CLASSES : ACTIVE_TAB_CLASSES));
        otherTab.classList.add(...(isActive ? ACTIVE_TAB_CLASSES : INACTIVE_TAB_CLASSES));
      }

      return;
    }

    const playButton = event.target.closest('[data-ipo-video-play]');
    if (playButton) {
      const wrap = playButton.closest('[data-ipo-video-wrap]');
      const video = wrap?.querySelector('video');
      if (!video) return;

      video.play();
      video.controls = true;
      playButton.classList.add('hidden');
      wrap.querySelector('[data-ipo-video-poster]')?.classList.add('hidden');
    }
  });
}
